import React, { Component } from 'react'
import { SignupForm } from 'app/common/forms'
import { FormattedMessage, injectIntl, useIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'
import { media, style } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import styled from 'styled-components'
import { H6 } from 'app/common/typography'
import { Link } from 'app/common/link'
import { SplitScreenLayout } from 'app/common/layout'
import { useLocation } from 'react-router-dom'

type Props = {
    fetchPageData: () => void,
    reset: () => void,
    error: any,
    networkError: any,
    intl: IntlShape
}

class Signup extends Component<Props> {
    componentDidMount() {
        const { fetchPageData, reset } = this.props
        reset()
        fetchPageData()
    }

    render() {
        const { error, networkError, intl } = this.props
        const rightBlock = (
            <Inline>
                <FormattedMessage id="signup.login.label">
                    {(text: string) => <H6>{text}</H6>}
                </FormattedMessage>
                <LinkToLogin />
            </Inline>
        )
        return (
            <SplitScreenLayout
                breadcrumbKey="signup.breadcrumb.end"
                titleKey="signup.title"
                leftBlock={<SignupForm />}
                rightBlock={rightBlock}
                noBackground
                error={error}
                networkError={networkError}
            />
        )
    }
}

const LinkToLogin = () => {
    const intl = useIntl()

    return (
        <StyledButtonMedium url={intl.formatMessage({ id: 'routes.signin' })}>
            <FormattedMessage id="signup.login.button" />
        </StyledButtonMedium>
    )
}

const Inline = styled.div`
    display: block;
    ${media.medium`
        display: flex;
        justify-content: space-between;
        align-items: center;
    `};
`

const StyledButtonMedium = styled(Link)`
    ${style.buttonMedium};
    margin-top: 20px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    background: ${colors.yellow};
    border: none;
    ${media.medium`
        margin-top: 0;
        left: 0;
        transform: none;
    `};
`

const SignupComponent = injectIntl(Signup)

export { SignupComponent }
